export default __webpack_public_path__ + "static/media/yield-overview.4677aaff.svg";